import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";

function ProjectCards(props) {
  return (
<Card className="project-card-view" style={{ height: "400px", display: "flex", flexDirection: "column" }}>
  <div className="card-image-container">
    <Card.Img variant="top" src={props.imgPath} alt="card-img" />
  </div>
  <Card.Body style={{ flex: "1" }}>
    <Card.Title>{props.title}</Card.Title>
    <Card.Text style={{ textAlign: "justify", flex: "1 1 auto" }}>
      {props.description}
    </Card.Text>
  </Card.Body>
  <div style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
    <Button variant="primary" href={props.demoLink} target="_blank">
      <CgWebsite /> &nbsp;
      {"View More"}
    </Button>
  </div>
</Card>


  );
}
export default ProjectCards;
